import { render, staticRenderFns } from "./accessibilita.vue?vue&type=template&id=ce39fe64"
import script from "./accessibilita.vue?vue&type=script&lang=js"
export * from "./accessibilita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports